import script from "./PMAMoreInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PMAMoreInfo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__